/**
 * Shipping date line item properties and product page display
 *
 * Keeps everything rendered from the snr.shipping_date variant metafield in sync with
 * the variant the shopper has selected:
 *
 *   [data-est-ship-date-input]    hidden inputs on the add-to-cart form
 *                                   Est Ship Date   "Nov 15, 2026"  shown in the cart
 *                                   _shipping_date  "2026-11-15"    machine readable
 *   [data-est-ship-date-display]  the "Estimated ship date" line on the product page
 *
 * Both carry the same variant id -> properties map in data-est-ship-dates. When the
 * selected variant has no date the inputs are disabled, so nothing is submitted, and
 * the display is hidden, so no stale or empty date is shown.
 */
(function () {
  var INPUT_SELECTOR = '[data-est-ship-date-input]';
  var DISPLAY_SELECTOR = '[data-est-ship-date-display]';
  var TARGET_SELECTOR = INPUT_SELECTOR + ', ' + DISPLAY_SELECTOR;
  var DISPLAY_PROPERTY = 'Est Ship Date';
  var PROPERTY_NAME = /^properties\[(.*)\]$/;

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function isInput(el) {
    return el.hasAttribute('data-est-ship-date-input');
  }

  function propertyMap(el) {
    if (!el.estShipDates) {
      try {
        el.estShipDates = JSON.parse(el.getAttribute('data-est-ship-dates') || '{}');
      } catch (e) {
        el.estShipDates = {};
      }
    }

    return el.estShipDates;
  }

  function propertyName(input) {
    var match = PROPERTY_NAME.exec(input.getAttribute('name') || '');

    return match ? match[1] : null;
  }

  function apply(el, properties) {
    if (isInput(el)) {
      var value = properties && properties[propertyName(el)];

      el.value = value || '';
      el.disabled = !value;
      return;
    }

    var date = properties && properties[DISPLAY_PROPERTY];
    var valueEl = el.querySelector('[data-est-ship-date-value]');

    if (valueEl) {
      valueEl.textContent = date || '';
    }

    el.hidden = !date;
  }

  // An input belongs to its own form. The display block sits outside the form, next to
  // the title or the price, so it reads the variant from its section instead.
  function scopeFor(el) {
    if (isInput(el)) {
      return el.form || (el.closest && el.closest('form'));
    }

    return (el.closest && el.closest('.shopify-section')) || document;
  }

  function selectedVariantId(el) {
    var scope = scopeFor(el);
    var variantInput = scope && scope.querySelector('[name="id"]');

    return variantInput ? String(variantInput.value) : null;
  }

  function sync(el) {
    apply(el, propertyMap(el)[selectedVariantId(el)]);
  }

  function syncAll(scope) {
    toArray((scope || document).querySelectorAll(TARGET_SELECTOR)).forEach(sync);
  }

  // Every property mapped for a variant anywhere on the page. Used by the ajax cart
  // when it builds bundle / subscription line items that have no form of their own.
  function getFor(variantId) {
    var key = String(variantId);
    var match = null;

    toArray(document.querySelectorAll(TARGET_SELECTOR)).some(function (el) {
      match = propertyMap(el)[key] || null;
      return Boolean(match);
    });

    return match;
  }

  // The theme's variant-selection element reports the new variant directly, which
  // avoids depending on the order the hidden id input is updated in. Scoping to the
  // section rather than the form also covers the display block.
  document.addEventListener('variant-change', function (event) {
    var section = event.target.closest && event.target.closest('.shopify-section');
    var variant = event.detail && event.detail.variant;
    var variantId = variant ? String(variant.id) : null;

    toArray((section || document).querySelectorAll(TARGET_SELECTOR)).forEach(function (el) {
      apply(el, variantId ? propertyMap(el)[variantId] : null);
    });
  }, true);

  // Fallback for forms where the variant select is changed without a variant-change event.
  document.addEventListener('change', function (event) {
    var target = event.target;

    if (target && target.name === 'id') {
      syncAll(target.closest('.shopify-section') || target.form);
    }
  });

  // Capture phase runs before the theme's add-to-cart handlers, so the properties are
  // correct both for a native submit and for the serialized /cart/add.js request.
  document.addEventListener('click', function (event) {
    var form = event.target.closest && event.target.closest('form');

    if (form) {
      syncAll(form);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    syncAll(event.target);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
    });
  } else {
    syncAll();
  }

  window.MolekuleEstShipDate = {
    sync: sync,
    syncAll: syncAll,
    getFor: getFor
  };
})();
